<div class="card dialog-box">
  <div class="card-header">
    Request Leave

    <span (click)="onCloseDialog()" class="float-end">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <form [formGroup]="leaveForm">
    <div class="mb-2">
      <gtapp-gt-calendar
        (onSelectDate)="onSelectDate($event)"
      ></gtapp-gt-calendar>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <div class="input-group">
        <textarea
          class="form-control"
          cols="32"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Provide the reason for applying leave"
          formControlName="reason"
          id="leaveReasonField"
        ></textarea>
        @if (leaveForm.value.reason) {
          <span
            class="input-group-text"
            (click)="clearAndFocusInputField('leaveReasonField')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="d-flex flex-wrap gap-2">
        @for (ltype of [0, 1, 2]; track ltype) {
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              [id]="'leave-session-' + ltype"
              [value]="ltype"
              formControlName="leave_session"
            />
            <label class="form-check-label" [for]="'leave-session-' + ltype">
              {{ leaveSessionDict?.[ltype] }}
            </label>
          </div>
        }
      </div>
    </div>
  </form>
  <div class="mt-3 row row-cols-2 pb-5 pb-lg-0">
    <div class="col">
      <button class="btn btn-dark btn-lg w-100" (click)="onCloseDialog()">
        Cancel
      </button>
    </div>
    <div class="col">
      <button
        class="btn btn-success btn-lg w-100"
        (click)="submitLeaves()"
        [disabled]="!leaveForm.valid"
      >
        Apply
      </button>
    </div>
  </div>
</div>
